// Spreadsheet apps evaluate cells that start with these characters as formulas
// (CWE-1236), even when the CSV field is quoted. TAB/CR count at position 0;
// the others after optional leading whitespace.
const FORMULA_PREFIX = /^(?:[\t\r]|\s*[=+\-@])/;
// Plain signed numbers are harmless and must stay numeric (e.g. "-5.00").
const PLAIN_NUMBER = /^-?\d+(\.\d+)?$/;

/**
 * Prefix a single quote to string values a spreadsheet would interpret as a
 * formula, so they are displayed as literal text. Non-strings and plain
 * numbers are returned untouched.
 */
const neutralizeCsvFormula = value =>
	typeof value === 'string' &&
	FORMULA_PREFIX.test(value) &&
	!PLAIN_NUMBER.test(value)
		? `'${value}`
		: value;

export default neutralizeCsvFormula;
